module.exports = __webpack_public_path__ + "static/media/UN-04.029ced36.jpg";